import React, { useContext } from 'react';
import { UserContext } from '../UserContext';

const CheckRole = ({ roles, children }) => {
    const { user } = useContext(UserContext);
    const userData = JSON.parse(localStorage.getItem('userData'));

    if (!userData || !Array.isArray(userData.listaPapeis)) {
        return <div>Loading...</div>; // Ou um componente de loading apropriado
    }

    const userRoles = userData.listaPapeis.map(papelUsuario => papelUsuario.papel.nome);

    const hasRequiredRole = roles.some(role => userRoles.includes(role));

    if (!hasRequiredRole) {
        return null; // Ou redirecionar para uma página de acesso negado
    }

    return children;
};

export default CheckRole;
